export default "__VITE_ASSET__BH8rMI2y__"